import { getField } from 'vuex-map-fields';

export default {
  webhooks: state => state.webhooks,
  webhooksLoaded: state => state.webhooksLoaded,
  webhookSaved: state => state.webhookSaved,
  webhookDeleted: state => state.webhookDeleted,

  webhookTypes: state => state.webhookTypes,
  webhookTypesLoaded: state => state.webhookTypesLoaded,

  webhookLogs: state => state.webhookLogs,
  webhookLogsLoaded: state => state.webhookLogsLoaded,

  apiError: state => state.apiError,
  getField,
};
